export enum ManagementFeeFundPeriod {
  INVESTMENT_PERIOD = 'INVESTMENT_PERIOD',
  POST_INVESTMENT_PERIOD = 'POST_INVESTMENT_PERIOD',
}

export const MANAGEMENT_FEE_FUND_PERIOD_LABELS: Record<
  ManagementFeeFundPeriod,
  string
> = {
  [ManagementFeeFundPeriod.INVESTMENT_PERIOD]: 'Investment Period',
  [ManagementFeeFundPeriod.POST_INVESTMENT_PERIOD]: 'Post-Investment Period',
};

export enum ManagementFeeCalculationBasis {
  COMMITTED_CAPITAL = 'COMMITTED_CAPITAL',
  INVESTED_CAPITAL = 'INVESTED_CAPITAL',
  NET_ASSET_VALUE = 'NET_ASSET_VALUE',
}

export const MANAGEMENT_FEE_CALCULATION_BASIS_LABELS: Record<
  ManagementFeeCalculationBasis,
  string
> = {
  [ManagementFeeCalculationBasis.COMMITTED_CAPITAL]: 'Committed Capital',
  [ManagementFeeCalculationBasis.INVESTED_CAPITAL]: 'Invested Capital',
  [ManagementFeeCalculationBasis.NET_ASSET_VALUE]: 'Net Asset Value',
};

export enum ManagementFeeAccrualFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  ANNUALLY = 'ANNUALLY',
}

export const MANAGEMENT_FEE_ACCRUAL_FREQUENCY_LABELS: Record<
  ManagementFeeAccrualFrequency,
  string
> = {
  [ManagementFeeAccrualFrequency.MONTHLY]: 'Monthly',
  [ManagementFeeAccrualFrequency.QUARTERLY]: 'Quarterly',
  [ManagementFeeAccrualFrequency.SEMI_ANNUALLY]: 'Semi-annually',
  [ManagementFeeAccrualFrequency.ANNUALLY]: 'Annually',
};

export interface ManagementFeeSchedule {
  id: string;
  fund_id: string;
  fund_period: ManagementFeeFundPeriod;
  effective_from: string;
  effective_to: string | null;
  description: string | null;
  calculation_basis: ManagementFeeCalculationBasis;
  annual_rate: number;
  accrual_frequency: ManagementFeeAccrualFrequency;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ManagementFeeScheduleCreate {
  fund_period: ManagementFeeFundPeriod;
  effective_from: string;
  effective_to?: string | null;
  description?: string | null;
  calculation_basis: ManagementFeeCalculationBasis;
  annual_rate: number;
  accrual_frequency: ManagementFeeAccrualFrequency;
  is_active?: boolean;
}

export interface ManagementFeeScheduleUpdate {
  fund_period?: ManagementFeeFundPeriod;
  effective_from?: string;
  effective_to?: string | null;
  description?: string | null;
  calculation_basis?: ManagementFeeCalculationBasis;
  annual_rate?: number;
  accrual_frequency?: ManagementFeeAccrualFrequency;
  is_active?: boolean;
}

export interface ManagementFeeSchedulePage {
  items: ManagementFeeSchedule[];
  total_count: number;
  page: number;
  page_size: number;
}

export interface ManagementFeeSummary {
  total_schedules: number;
  active_schedules: number;
  average_annual_rate: number;
  average_annual_rate_all: number;
}

export enum ManagementFeeSettlement {
  BANK = 'BANK',
  MANAGER_CURRENT_ACCOUNT = 'MANAGER_CURRENT_ACCOUNT',
}

export const MANAGEMENT_FEE_SETTLEMENT_LABELS: Record<
  ManagementFeeSettlement,
  string
> = {
  [ManagementFeeSettlement.BANK]: 'Bank',
  [ManagementFeeSettlement.MANAGER_CURRENT_ACCOUNT]: 'Manager current account',
};
